


export class FBL1N {
  "account";
  "documentNumber";
  "reference";
  "documentType";
  "termsOfPayment";
  "documentDate";
  "postingDate";
  "netDueDate";
  "amountInLocalCurrency";
  "localCurrency";
  "amountInDocCurr";
  "documentCurrency";
  "paymentBlock";
  "text";
  "clearingDate";
  "sortKey";
  "purchasingDocument";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FBL1N`.
   */
  static getModelName() {
    return "FBL1N";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FBL1N for dynamic purposes.
  **/
  static factory(data) {
    return new FBL1N(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'FBL1N',
      plural: 'FBL1Ns',
      path: 'FBL1Ns',
      properties: {
        "account": {
          name: 'account',
          type: 'string'
        },
        "documentNumber": {
          name: 'documentNumber',
          type: 'string'
        },
        "reference": {
          name: 'reference',
          type: 'string'
        },
        "documentType": {
          name: 'documentType',
          type: 'string'
        },
        "termsOfPayment": {
          name: 'termsOfPayment',
          type: 'string'
        },
        "documentDate": {
          name: 'documentDate',
          type: 'string'
        },
        "postingDate": {
          name: 'postingDate',
          type: 'string'
        },
        "netDueDate": {
          name: 'netDueDate',
          type: 'string'
        },
        "amountInLocalCurrency": {
          name: 'amountInLocalCurrency',
          type: 'string'
        },
        "localCurrency": {
          name: 'localCurrency',
          type: 'string'
        },
        "amountInDocCurr": {
          name: 'amountInDocCurr',
          type: 'string'
        },
        "documentCurrency": {
          name: 'documentCurrency',
          type: 'string'
        },
        "paymentBlock": {
          name: 'paymentBlock',
          type: 'string'
        },
        "text": {
          name: 'text',
          type: 'string'
        },
        "clearingDate": {
          name: 'clearingDate',
          type: 'string'
        },
        "sortKey": {
          name: 'sortKey',
          type: 'string'
        },
        "purchasingDocument": {
          name: 'purchasingDocument',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/FBL1N.js